export default {
  badge: 'Žetons',
  open: 'Atvērt',
  close: 'Aizvērt',
  dismiss: 'Noraidīt',
  confirmEdit: {
    ok: 'Labi',
    cancel: 'Atcelt',
  },
  dataIterator: {
    noResultsText: 'Nekas netika atrasts',
    loadingText: 'Ielādē...',
  },
  dataTable: {
    itemsPerPageText: 'Rādīt lapā:',
    ariaLabel: {
      sortDescending: 'Sakārtots dilstošā secībā.',
      sortAscending: 'Sakārtots augošā secībā.',
      sortNone: 'Nav sakārtots.',
      activateNone: 'Aktivizēt, lai noņemtu kārtošanu.',
      activateDescending: 'Aktivizēt, lai sakārtotu dilstošā secībā.',
      activateAscending: 'Aktivizēt, lai sakārtotu augošā secībā.',
    },
    sortBy: 'Kārtot pēc',
  },
  dataFooter: {
    itemsPerPageText: 'Rādīt lapā:',
    itemsPerPageAll: 'Visu',
    nextPage: 'Nākamā lapa',
    prevPage: 'Iepriekšējā lapa',
    firstPage: 'Pirmā lapa',
    lastPage: 'Pēdējā lapa',
    pageText: '{0}-{1} no {2}',
  },
  dateRangeInput: {
    divider: 'līdz',
  },
  datePicker: {
    itemsSelected: '{0} izvēlēts',
    range: {
      title: 'Izvēlieties datumus',
      header: 'Ievadiet datumus',
    },
    title: 'Izvēlieties datumu',
    header: 'Ievadiet datumu',
    input: {
      placeholder: 'Ievadiet datumu',
    },
  },
  noDataText: 'Nav pieejamu datu',
  carousel: {
    prev: 'Iepriekšējais slaids',
    next: 'Nākamais slaids',
    ariaLabel: {
      delimiter: 'Karuseļa slaids {0} no {1}',
    },
  },
  calendar: {
    moreEvents: 'Vēl {0}',
    today: 'Šodien',
  },
  input: {
    clear: 'Notīrīt {0}',
    prependAction: '{0} pievienota darbība sākumā',
    appendAction: '{0} pievienota darbība beigās',
    otp: 'Lūdzu, ievadiet OTP simbolu {0}',
  },
  fileInput: {
    counter: '{0} faili',
    counterSize: '{0} faili (kopā {1})',
  },
  fileUpload: {
    title: 'Velciet un nometiet failus šeit',
    divider: 'vai',
    browse: 'Pārlūkot failus',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Izvēlieties laiku',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigācija lapošanā',
      next: 'Nākamā lapa',
      previous: 'Iepriekšējā lapa',
      page: 'Iet uz lapu {0}',
      currentPage: 'Pašreizējā lapa, lapa {0}',
      first: 'Pirmā lapa',
      last: 'Pēdējā lapa',
    },
  },
  stepper: {
    next: 'Nākamais',
    prev: 'Iepriekšējais',
  },
  rating: {
    ariaLabel: {
      item: 'Vērtējums {0} no {1}',
    },
  },
  loading: 'Ielādē...',
  infiniteScroll: {
    loadMore: 'Ielādēt vairāk',
    empty: 'Nav vairāk vienumu',
  },
  rules: {
    required: 'Šis lauks ir obligāts',
    email: 'Lūdzu, ievadiet derīgu e-pasta adresi',
    number: 'Šis lauks var saturēt tikai ciparus',
    integer: 'Šis lauks var saturēt tikai veselus skaitļus',
    capital: 'Šis lauks var saturēt tikai lielos burtus',
    maxLength: 'Jums jāievada maksimāli {0} rakstzīmes',
    minLength: 'Jums jāievada vismaz {0} rakstzīmes',
    strictLength: 'Ievadītā lauka garums nav derīgs',
    exclude: 'Rakstzīme {0} nav atļauta',
    notEmpty: 'Lūdzu, izvēlieties vismaz vienu vērtību',
    pattern: 'Nederīgs formāts',
  },
  hotkey: {
    then: 'tad',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Augšup bulta',
    downArrow: 'Lejup bulta',
    leftArrow: 'Kreisā bulta',
    rightArrow: 'Labā bulta',
    backspace: 'Atpakaļatkāpe',
    space: 'Atstarpe',
    plus: 'plus',
    shortcut: 'Tastatūras saīsne: {0}',
  },
}
